import api from "../../api/index";

const getbusinessprofile = `${process.env.VUE_APP_BASE_URI}/business-api`;
const updatebusinessprofile = `${process.env.VUE_APP_BASE_URI}/auth/company/profile`;

const getDefaultState = () => {
  return {
    businessprofile: [],
    status: "",
  };
};

const state = getDefaultState();

const getters = {
  businessprofile: (state) => state.businessprofile,
};
const actions = {
  async getBusinessProfile({ commit }) {
    commit("getbusinessprofile_request");
    const res = await api.get(getbusinessprofile);
    if (res.data.status === "success") {
      commit("getbusinessprofile_success", res.data.profile);
    }
    return res;
  },
  async updateBusinessProfile({ commit }, updatedbusinessprofile) {
    commit("updatebusinessprofile_request");
    const res = await api.patch(updatebusinessprofile, updatedbusinessprofile);
    if (res.data.success) {
      commit("updatebusinessprofile_success");
    }
    return res;
  },

  async resetBusinessProfileState({ commit }) {
    await commit("resetbusinessprofilestate_success");
  },
};

const mutations = {
  getbusinessprofile_request: (state) => (state.status = "loading"),
  getbusinessprofile_success: (state, profile) => {
    state.status = "success";
    state.businessprofile = profile;
  },
  updatebusinessprofile_request: (state) => (state.status = "loading"),
  updatebusinessprofile_success: (state) => {
    state.status = "success";
  },
  resetbusinessprofilestate_success: (state) =>
    Object.assign(state, getDefaultState()),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
